import SeoLandingPage from "@/components/SeoLandingPage";

const GitRemoteWorkflow = () => <SeoLandingPage pageKey="gitRemoteWorkflow" />;

export default GitRemoteWorkflow;
